import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
import { Button } from "components"

export const UserLogin = () => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <div className="w-[96%] mx-auto mt-6">
   <h1 className="Jakarta-font font-semibold pb-3">{t("userMessage")}</h1>
   <Box bg="highlight" className="Jakarta-font py-5 px-4 rounded">
    <h1 className="font-semibold">{t("report")}</h1>

    <div className="flex flex-col justify-center w-full py-4">
     <label className="text-sm font-semi" htmlFor="text">
      {t("messageText")}
     </label>
     <input
      id="text"
      className="bg-gray py-2 outline-none rounded px-2 text-black "
      type="text"
      placeholder={`${t("enterHere")}...`}
     />
    </div>

    <div className="flex justify-end">
     {" "}
     <div>
      <Button size={"xl"}>{t("send")}</Button>
     </div>
    </div>
   </Box>
  </div>
 )
}
